<template>
    <transition
        mode="out-in"
        @enter="animateIn"
        @leave="animateOut"
        :css="false"
        appear>

        <div v-if="showcase.id == pageId" :class="{ [ 'showcase-' + showcase.id ]:true, imgTitleBlock:true }" >
            <!-- <div class="top">
                <div class="image-wrapper">
                    <img class="showcaseImg" :src="require(`@/static/img/${showcase.img}`)" />
                    <img :src="require(`@/static/img/computer.svg`)" />
                </div>
                <div class="text">
                    <h2 class="title">{{ showcase.title }}</h2>
                    <p class="type"><span>{{ showcase.type }}{{ showcase.publisher }}</span></p>
                </div>
            </div> -->
            <!-- <div class="bottom">
                <p class="tech">{{ showcase.tech }}</p>
                <p class="summary">{{ showcase.summary }}</p>
                <a :href="`${showcase.route}`" target="_blank"><button class="caseLink">view case<span class="disclaimer" v-if="showcase.type == 'BANNERS'">Don't forget<br>to turn off your<br>ad blockers</span></button></a>
            </div> -->
            <div class="image-wrapper">
                <img class="showcaseImg" :src="require(`@/static/img/${showcase.img}`)" />
                <img :src="require(`@/static/img/computer.svg`)" />
            </div>
            <div class="text">
                <h2 class="title">{{ showcase.title }}</h2>
                <p class="type"><span>{{ showcase.type }}{{ showcase.publisher }}</span></p>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax } from '@/vendor';
    export default {
        props: {
            pageId:{
                type: Number,
                default: 0
            },
            showcase: {
                type: Object,
                default: () => { }
            }
        },
        
        data()
        {
            return {

            };
        },

        methods: {

            animateIn( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });

                tl.add('frame1', 0.5);

                tl.staggerFrom(['.showcase-' + this.showcase.id + ' .text', '.showcase-' + this.showcase.id + ' .bottom'], 0.5, { y: 10, autoAlpha: 0 }, 'frame1+=0.5');
                tl.from('.showcase-' + this.showcase.id + ' img', 1, { autoAlpha: 0 }, 'frame1');
            },

            animateOut( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });

                tl.add('frame1', 0);

                tl.to('.showcase-' + this.showcase.id + ' img', 0.5, { autoAlpha: 0 }, 'frame1');
                tl.to(['.showcase-' + this.showcase.id + ' .text', '.showcase-' + this.showcase.id + ' .bottom'], 0.5, { y: -10, autoAlpha: 0 }, 'frame1');
            }
        }
    };
</script>